/** Set to true when subscription plans are reintroduced. */
export const PRO_PLANS_ENABLED = false;
